import React from 'react';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import {Form, Card, Row, Col, Select} from 'antd';
import { SPAN_FULL } from '../../../../../../../styles/constants';
import {connect} from 'react-redux';
import _ from "lodash";

const mapStateToProps = state => ({
    mergedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.mergedHeader,
});

const mapPropsToFields = ({value}) => ({
    selectValue: Form.createFormField({value: value !== null ? value.selectValue : null}),
})

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const ConcatForm = ({
                      t,
                      form,
                      mergedHeader
                    }) =>
  <Form>
    <Form.Item
      className="form-item"
      label={t('data.fileMapping.addField.functionWizard.field.label')}
    >
        <Card>
            <Row type='flex' justify='space-between'>
                <Col span={SPAN_FULL}>
                    {form.getFieldDecorator("selectValue")(
                      <Select
                        title={form.getFieldValue("selectValue")}
                        >
                        {mergedHeader.map((field) => (
                          <Select.Option
                            key={field.name}
                            value={field.name}
                            title={`${field.name}`}
                          >
                            {field.name}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                </Col>
            </Row>
        </Card>
    </Form.Item>
  </Form>;

export default compose(
    translate(),
    connect(mapStateToProps),
    Form.create({mapPropsToFields, onFieldsChange})
)(ConcatForm);
